import React from "react";
import styles from "./AboutUs.module.css";

export default function AboutUs() {
  return (
    <div className="darkSectionContent" id="aboutUs">
      <div className="lightSectionTitle">
        <h1>Poznaj nas</h1>
      </div>
      <div className={styles.sectionDescription}>
        <p>
          Jesteśmy miejscem, w którym bezpiecznie i szybko Twoje auto otrzyma
          nowe opony. Zajmujemy się zmianą opon przez cały rok. Zapraszamy
          zarówno w sezonie letnim jaki i zimowym, a także wtedy jak zajedzie
          potrzeba ich wymiany. Służymy pomocą w przypadku chęci zakupu nowych
          opon.
        </p>
      </div>
      <div className={styles.strengths}>
        <div className={styles.item}>
          <img
            src={`${process.env.PUBLIC_URL}/Images/strong.webp`}
            alt="strong"
            className={styles.imageItem}
          />
          <p className={styles.descriptionItem}>Siła</p>
        </div>
        <div className={styles.item}>
          <img
            src={`${process.env.PUBLIC_URL}/Images/precision.webp`}
            alt="precision"
            className={styles.imageItem}
          />
          <p className={styles.descriptionItem}>Precyzja</p>
        </div>
        <div className={styles.item}>
          <img
            src={`${process.env.PUBLIC_URL}/Images/speed.webp`}
            alt="speed"
            className={styles.imageItem}
          />
          <p className={styles.descriptionItem}>Szybkość</p>
        </div>
      </div>
    </div>
  );
}
